import { GridColDef } from '@mui/x-data-grid';
import React from 'react';
import { format } from 'date-fns';

export const toFormattedDate = (date: Date) => {
  return format(date, "dd.MM.yyyy' 'HH:mm");
};

export const ADMIN_BALANCE_GRID_COLUMNS: GridColDef[] = [
  {
    field: 'amount',
    headerName: 'Операция',
    width: 130,
    renderCell: (params) => (
      <span>
        {params.row.operation} {params.row.amount}
      </span>
    ),
  },
  {
    field: 'remains',
    headerName: 'Остаток',
    width: 120,
  },
  {
    field: 'date',
    headerName: 'Дата',
    flex: 1,
    renderCell: (params) => {
      return <span>{toFormattedDate(new Date(params.value.replace(/"/g, '')))}</span>;
    },
  },
];
